import { THEME_BACKGROUND_COLORS, type ThemeMode } from "@/features/theme/theme-config";

export const THEME_STORAGE_KEY = "predik-theme:v1";

const LEGACY_THEME_STORAGE_KEY = "predik-theme";

export type { ThemeMode } from "@/features/theme/theme-config";

export function isThemeMode( value: string | undefined ): value is ThemeMode {
    return value === "light" || value === "dark";
}

export function getSystemThemeMode(): ThemeMode {
    if ( typeof window === "undefined" ) {
        return "light";
    }

    return window.matchMedia( "(prefers-color-scheme: dark)" ).matches ? "dark" : "light";
}

export function getStoredThemeMode(): ThemeMode {
    if ( typeof window === "undefined" ) {
        return "light";
    }

    let storedTheme: string | undefined;
    try {
        storedTheme = localStorage.getItem( THEME_STORAGE_KEY )
            ?? localStorage.getItem( LEGACY_THEME_STORAGE_KEY )
            ?? undefined;
    } catch {
        storedTheme = undefined;
    }

    if ( isThemeMode( storedTheme ) ) {
        return storedTheme;
    }

    return getSystemThemeMode();
}

export function applyThemeMode( themeMode: ThemeMode ) {
    document.documentElement.dataset.theme = themeMode;
    document.documentElement.classList.toggle( "dark", themeMode === "dark" );

    const themeColorMeta = document.querySelector<HTMLMetaElement>( "meta[name=\"theme-color\"]" ) ?? undefined;
    if ( themeColorMeta ) {
        themeColorMeta.content = THEME_BACKGROUND_COLORS[themeMode];
    }

    try {
        localStorage.setItem( THEME_STORAGE_KEY, themeMode );
        localStorage.removeItem( LEGACY_THEME_STORAGE_KEY );
    } catch {
        //
    }
}
